import { useQuery } from '@apollo/client'

import {
  OrderDetailsEditInfoDocument,
  OrderDetailsEditInfoQuery,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
query OrderDetailsEditInfo($brandId: ID!, $retailerId: ID!, $isBrand: Boolean!, $shouldFetchConnection: Boolean!) {
  brands(filter: {brandIds: [$brandId]}) {
    edges {
      node {
        id
        seasons {
          edges {
            node {
              id
              name
            }
          }
        }
        orderEvents(orderBy: {field: CREATION_DATE, order: ASCENDING}) @include(if: $isBrand) {
          id
          name
          code
        }
        orderTypes @include(if: $isBrand){
          edges {
            node {
              id
              name
              code
            }
          }
        }
        warehouses @include(if: $isBrand){
          edges {
            node {
              id
              code
              name
            }
          }
        }
      }
    }
  }
  listConnectionWarehouses(input: {retailerId: $retailerId}) @include(if: $shouldFetchConnection){
    	warehouseId
  }
}
`
export const useOrderDetailsEditInfo = ({
  brandId,
  retailerId,
  isBrand,
}: {
  brandId: string
  retailerId: string
  isBrand: boolean
}) => {
  const { data, loading } = useQuery<OrderDetailsEditInfoQuery>(
    OrderDetailsEditInfoDocument,
    {
      variables: {
        brandId,
        retailerId,
        isBrand,
        shouldFetchConnection: isBrand && Boolean(retailerId),
      },
      skip: !brandId,
      client: atlasClient,
    },
  )

  return {
    data,
    loading,
  }
}
